import * as PlaylistConstants from '../../constants';
import PlaylistWorkers from '../workers/index';

export default [
  {
    actionType: PlaylistConstants.ActionKeys.GET_AND_ADD_REPLAY_TRACK,
    handler: PlaylistWorkers.getAndAddReplayTrack,
    concur: 'takeEvery',
  },
];
